export default __webpack_public_path__ + "d42134cfd3e13e4fea5b27dec21a2d6e.svg";